import { createTranslationMessages } from '@backstage/core-plugin-api/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';

const scaffolderPtbr = createTranslationMessages({
    ref: scaffolderTranslationRef,
    messages: {
        'fields.entityNamePicker.title': 'Nome',
        'fields.entityNamePicker.description': 'Nome único do componente',
        'fields.entityPicker.title': 'Entidade',
        'fields.entityPicker.description': 'Uma entidade do catálogo',
        'fields.entityTagsPicker.title': 'Tags',
        'fields.entityTagsPicker.description':
            "Adicione tags relevantes, pressione 'Enter' para adicionar novas tags. Formato válido: [a-z0-9+#] separado por [-], no máximo 63 caracteres",
        'fields.multiEntityPicker.title': 'Entidade',
        'fields.multiEntityPicker.description': 'Uma entidade do catálogo',
        'fields.myGroupsPicker.title': 'Entidade',
        'fields.myGroupsPicker.description': 'Uma entidade do catálogo',
        'fields.ownedEntityPicker.title': 'Entidade',
        'fields.ownedEntityPicker.description': 'Uma entidade do catálogo',
        'fields.ownerPicker.title': 'Proprietário',
        'fields.ownerPicker.description': 'O proprietário do componente',
        'fields.azureRepoPicker.organization.title': 'Organização',
        'fields.azureRepoPicker.organization.description':
            'A organização a qual este repositório pertencerá',
        'fields.azureRepoPicker.project.title': 'Projeto',
        'fields.azureRepoPicker.project.description':
            'O projeto ao qual este repositório pertencerá',
        'fields.bitbucketRepoPicker.project.title': 'Projetos Permitidos',
        'fields.bitbucketRepoPicker.project.description':
            'O projeto ao qual este repositório pertencerá',
        'fields.bitbucketRepoPicker.project.inputTitle': 'Projetos',
        'fields.bitbucketRepoPicker.workspaces.title': 'Workspaces Permitidos',
        'fields.bitbucketRepoPicker.workspaces.description':
            'O workspace ao qual este repositório pertencerá',
        'fields.bitbucketRepoPicker.workspaces.inputTitle': 'Workspaces',
        'fields.gerritRepoPicker.parent.title': 'Pai',
        'fields.gerritRepoPicker.parent.description':
            'O projeto pai ao qual o repositório pertencerá',
        'fields.gerritRepoPicker.owner.title': 'Proprietário',
        'fields.gerritRepoPicker.owner.description':
            'O proprietário do projeto (opcional)',
        'fields.giteaRepoPicker.owner.title': 'Proprietário Disponível',
        'fields.giteaRepoPicker.owner.description':
            'Namespace do Gitea onde este repositório pertencerá. Pode ser o nome da organização, grupo, subgrupo, usuário ou projeto.',
        'fields.giteaRepoPicker.owner.inputTitle': 'Proprietário',
        'fields.githubRepoPicker.owner.title': 'Proprietário Disponível',
        'fields.githubRepoPicker.owner.description':
            'A organização, usuário ou projeto ao qual este repositório pertencerá',
        'fields.githubRepoPicker.owner.inputTitle': 'Proprietário',
        'fields.gitlabRepoPicker.owner.title': 'Proprietário Disponível',
        'fields.gitlabRepoPicker.owner.description':
            'Namespace do GitLab onde este repositório pertencerá. Pode ser o nome da organização, grupo, subgrupo, usuário ou projeto.',
        'fields.gitlabRepoPicker.owner.inputTitle': 'Proprietário',
        'fields.repoUrlPicker.host.title': 'Host',
        'fields.repoUrlPicker.host.description':
            'O host onde o repositório será criado',
        'fields.repoUrlPicker.repository.title': 'Repositórios Disponíveis',
        'fields.repoUrlPicker.repository.description': 'O nome do repositório',
        'fields.repoUrlPicker.repository.inputTitle': 'Repositório',
        'aboutCard.launchTemplate': 'Iniciar Template',
        'actionsPage.content.emptyState.title': 'Sem informações para exibir',
        'actionsPage.content.emptyState.description':
            'Não há ações instaladas ou houve um problema de comunicação com o backend.',
        'actionsPage.content.searchFieldPlaceholder': 'Procurar uma ação',
        'actionsPage.title': 'Ações instaladas',
        'actionsPage.action.input': 'Entrada',
        'actionsPage.action.output': 'Saída',
        'actionsPage.action.examples': 'Exemplos',
        'actionsPage.subtitle': 'Esta é a coleção de todas as ações instaladas',
        'actionsPage.pageTitle': 'Criar um Novo Componente',
        'listTaskPage.content.emptyState.title': 'Sem informações para exibir',
        'listTaskPage.content.emptyState.description':
            'Não há tarefas ou houve um problema de comunicação com o backend.',
        'listTaskPage.content.tableCell.template': 'Template',
        'listTaskPage.content.tableCell.status': 'Status',
        'listTaskPage.content.tableCell.owner': 'Proprietário',
        'listTaskPage.content.tableCell.created': 'Criado',
        'listTaskPage.content.tableCell.taskID': 'ID da Tarefa',
        'listTaskPage.content.tableTitle': 'Tarefas',
        'listTaskPage.title': 'Listar tarefas do template',
        'listTaskPage.subtitle': 'Todas as tarefas que foram iniciadas',
        'listTaskPage.pageTitle': 'Tarefas dos Templates',
        'ownerListPicker.title': 'Proprietário da Tarefa',
        'ownerListPicker.options.all': 'Todos',
        'ownerListPicker.options.owned': 'Próprios',
        'ongoingTask.title': 'Execução de',
        'ongoingTask.contextMenu.cancel': 'Cancelar',
        'ongoingTask.contextMenu.startOver': 'Recomeçar',
        'ongoingTask.contextMenu.retry': 'Tentar Novamente',
        'ongoingTask.contextMenu.hideLogs': 'Ocultar Logs',
        'ongoingTask.contextMenu.showLogs': 'Mostrar Logs',
        'ongoingTask.contextMenu.hideButtonBar': 'Ocultar Barra de Botões',
        'ongoingTask.contextMenu.showButtonBar': 'Mostrar Barra de Botões',
        'ongoingTask.subtitle': 'Tarefa {{taskId}}',
        'ongoingTask.pageTitle.hasTemplateName': 'Execução de {{templateName}}',
        'ongoingTask.pageTitle.noTemplateName': 'Execução do Scaffolder',
        'ongoingTask.cancelButtonTitle': 'Cancelar',
        'ongoingTask.retryButtonTitle': 'Tentar Novamente',
        'ongoingTask.startOverButtonTitle': 'Recomeçar',
        'ongoingTask.hideLogsButtonTitle': 'Ocultar Logs',
        'ongoingTask.showLogsButtonTitle': 'Mostrar Logs',
        'templateEditorForm.stepper.emptyText':
            'Não há parâmetros de especificação no template para visualizar.',
        'renderSchema.undefined': 'Nenhum schema definido',
        'renderSchema.tableCell.name': 'Nome',
        'renderSchema.tableCell.type': 'Tipo',
        'renderSchema.tableCell.title': 'Título',
        'renderSchema.tableCell.description': 'Descrição',
        'templatingExtensions.content.values.title': 'Valores',
        'templatingExtensions.content.values.notAvailable':
            'Não há valores de template globais definidos.',
        'templatingExtensions.content.emptyState.title':
            'Sem informações para exibir',
        'templatingExtensions.content.emptyState.description':
            'Não há extensões de template disponíveis ou houve um problema de comunicação com o backend.',
        'templatingExtensions.content.filters.title': 'Filtros',
        'templatingExtensions.content.filters.schema.input': 'Entrada',
        'templatingExtensions.content.filters.schema.output': 'Saída',
        'templatingExtensions.content.filters.schema.arguments': 'Argumentos',
        'templatingExtensions.content.filters.examples': 'Exemplos',
        'templatingExtensions.content.filters.notAvailable':
            'Não há filtros de template definidos.',
        'templatingExtensions.content.filters.metadataAbsent':
            'Metadados do filtro indisponíveis',
        'templatingExtensions.content.searchFieldPlaceholder':
            'Procurar uma extensão',
        'templatingExtensions.content.functions.title': 'Funções',
        'templatingExtensions.content.functions.schema.output': 'Saída',
        'templatingExtensions.content.functions.schema.arguments': 'Argumentos',
        'templatingExtensions.content.functions.examples': 'Exemplos',
        'templatingExtensions.content.functions.notAvailable':
            'Não há funções de template globais definidas.',
        'templatingExtensions.content.functions.metadataAbsent':
            'Metadados da função indisponíveis',
        'templatingExtensions.title': 'Extensões de Template',
        'templatingExtensions.subtitle':
            'Esta é a coleção de extensões de template disponíveis',
        'templatingExtensions.pageTitle': 'Extensões de Template',
        'templateTypePicker.title': 'Categorias',
        'templateIntroPage.title': 'Gerenciar Templates',
        'templateIntroPage.subtitle':
            'Edite, visualize e experimente templates, formulários e campos personalizados',
        'templateFormPage.title': 'Editor de Template',
        'templateFormPage.subtitle':
            'Edite, visualize e experimente formulários de template',
        'templateCustomFieldPage.title': 'Explorador de Campo Personalizado',
        'templateCustomFieldPage.subtitle':
            'Edite, visualize e experimente campos personalizados',
        'templateEditorPage.title': 'Editor de Template',
        'templateEditorPage.subtitle':
            'Edite, visualize e experimente templates e formulários de template',
        'templateEditorPage.dryRunResults.title': 'Resultados do teste',
        'templateEditorPage.dryRunResultsList.title': 'Resultado {{resultId}}',
        'templateEditorPage.dryRunResultsList.deleteButtonTitle':
            'Excluir resultado',
        'templateEditorPage.dryRunResultsList.downloadButtonTitle':
            'Baixar como .zip',
        'templateEditorPage.dryRunResultsView.tab.output': 'Saída',
        'templateEditorPage.dryRunResultsView.tab.log': 'Log',
        'templateEditorPage.dryRunResultsView.tab.files': 'Arquivos',
        'templateEditorPage.taskStatusStepper.skippedStepTitle': 'Pulado',
        'templateEditorPage.customFieldExplorer.preview.title':
            'Especificação do Template',
        'templateEditorPage.customFieldExplorer.fieldForm.title': 'Opções do Campo',
        'templateEditorPage.customFieldExplorer.fieldForm.applyButtonTitle':
            'Aplicar',
        'templateEditorPage.customFieldExplorer.selectFieldLabel':
            'Escolha a Extensão de Campo Personalizado',
        'templateEditorPage.customFieldExplorer.fieldPreview.title':
            'Visualização do Campo',
        'templateEditorPage.templateEditorBrowser.closeConfirmMessage':
            'Tem certeza? Alterações não salvas serão perdidas',
        'templateEditorPage.templateEditorBrowser.saveIconTooltip':
            'Salvar todos os arquivos',
        'templateEditorPage.templateEditorBrowser.reloadIconTooltip':
            'Recarregar diretório',
        'templateEditorPage.templateEditorBrowser.closeIconTooltip':
            'Fechar diretório',
        'templateEditorPage.templateEditorIntro.title':
            'Comece escolhendo uma das opções abaixo',
        'templateEditorPage.templateEditorIntro.loadLocal.title':
            'Carregar Diretório de Template',
        'templateEditorPage.templateEditorIntro.loadLocal.description':
            'Carregue um diretório de template local, permitindo que você edite e tente executar seu próprio template.',
        'templateEditorPage.templateEditorIntro.loadLocal.unsupportedTooltip':
            'Suportado apenas em alguns navegadores baseados em Chromium com a página carregada via HTTPS',
        'templateEditorPage.templateEditorIntro.createLocal.title':
            'Criar Novo Template',
        'templateEditorPage.templateEditorIntro.createLocal.description':
            'Crie um diretório de template local, permitindo que você edite e tente executar seu próprio template.',
        'templateEditorPage.templateEditorIntro.createLocal.unsupportedTooltip':
            'Suportado apenas em alguns navegadores baseados em Chromium com a página carregada via HTTPS',
        'templateEditorPage.templateEditorIntro.formEditor.title':
            'Playground de Formulário de Template',
        'templateEditorPage.templateEditorIntro.formEditor.description':
            'Visualize e edite um formulário de template, usando um template de exemplo ou carregando um template do catálogo.',
        'templateEditorPage.templateEditorIntro.fieldExplorer.title':
            'Explorador de Campo Personalizado',
        'templateEditorPage.templateEditorIntro.fieldExplorer.description':
            'Visualize e experimente as extensões de campo personalizado instaladas disponíveis.',
        'templateEditorPage.templateEditorTextArea.saveIconTooltip':
            'Salvar arquivo',
        'templateEditorPage.templateEditorTextArea.refreshIconTooltip':
            'Recarregar arquivo',
        'templateEditorPage.templateEditorTextArea.emptyStateParagraph':
            'Por favor, selecione uma ação no menu de arquivos.',
        'templateEditorPage.templateFormPreviewer.title':
            'Carregar Template Existente',
        'templateListPage.title': 'Criar um novo componente',
        'templateListPage.subtitle':
            'Crie novos componentes de software usando templates padrão em sua organização',
        'templateListPage.pageTitle': 'Criar um novo componente',
        'templateListPage.templateGroups.defaultTitle': 'Templates',
        'templateListPage.templateGroups.otherTitle': 'Outros Templates',
        'templateListPage.contentHeader.supportButtonTitle':
            'Crie novos componentes de software usando templates padrão. Diferentes templates criam diferentes tipos de componentes (serviços, sites, documentação, ...).',
        'templateListPage.contentHeader.registerExistingButtonTitle':
            'Registrar Componente Existente',
        'templateListPage.additionalLinksForEntity.viewTechDocsTitle':
            'Ver TechDocs',
        'templateWizardPage.title': 'Criar um novo componente',
        'templateWizardPage.subtitle':
            'Crie novos componentes de software usando templates padrão em sua organização',
        'templateWizardPage.pageTitle': 'Criar um novo componente',
        'templateWizardPage.pageContextMenu.editConfigurationTitle':
            'Editar Configuração',
        'templateEditorToolbar.customFieldExplorerTooltip':
            'Explorador de Campos Personalizados',
        'templateEditorToolbar.installedActionsDocumentationTooltip':
            'Documentação de Ações Instaladas',
        'templateEditorToolbar.templatingExtensionsDocumentationTooltip':
            'Documentação de Extensões de Template',
        'templateEditorToolbar.addToCatalogButton': 'Publicar',
        'templateEditorToolbar.addToCatalogDialogTitle': 'Publicar alterações',
        'templateEditorToolbar.addToCatalogDialogContent.stepsIntroduction':
            'Siga as instruções abaixo para criar ou atualizar um template:',
        'templateEditorToolbar.addToCatalogDialogContent.stepsListItems':
            'Salve os arquivos do template em um diretório local\nCrie um pull request para um repositório git novo ou existente\nSe o template já existir, as alterações serão refletidas no catálogo de software assim que o pull request for mesclado\nMas se você estiver criando um novo template, siga a documentação linkada abaixo para registrar o novo repositório de template no catálogo de software',
        'templateEditorToolbar.addToCatalogDialogActions.documentationUrl':
            'https://backstage.io/docs/features/software-templates/adding-templates/',
        'templateEditorToolbar.addToCatalogDialogActions.documentationButton':
            'Ir para a documentação',
        'templateEditorToolbarFileMenu.button': 'Arquivo',
        'templateEditorToolbarFileMenu.options.openDirectory':
            'Abrir diretório do template',
        'templateEditorToolbarFileMenu.options.createDirectory':
            'Criar diretório do template',
        'templateEditorToolbarFileMenu.options.closeEditor':
            'Fechar editor de template',
        'templateEditorToolbarTemplatesMenu.button': 'Templates',
    },
});

export default scaffolderPtbr;
